import { render, staticRenderFns } from "./AllStudents.vue?vue&type=template&id=0cf13122"
import script from "./AllStudents.vue?vue&type=script&lang=js"
export * from "./AllStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports